import { createContext } from "react";
export var OrderContext = createContext(null);
